import React, { Component } from 'react';
import {newOrder} from "../orders/EditOrderPage";
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import {Aux, DATE_SHORT_FORMAT, isNullEmptyOrWhitespace, IsNullOrUndefined, obsfucate, fabmod_send_po_to_nolans_all} from "../../constants";
import moment from "moment";
import DatePicker from "react-datepicker";
import FabricationAwning from "./FabricationAwning";
import TextBoxControl from "../common/TextBoxControl";
import SelectControl from "../common/SelectControl";
import TextViewControl from "../common/TextViewControl";
import {apiPost, apiRequest} from "../../utils/request";
import {some} from "lodash";
import {toastr} from "react-redux-toastr";
import PropTypes from "prop-types";

const ValidationRules = {
  organisationId: {
    validator: (val) => {
      return {isValid: (!IsNullOrUndefined(val) && val > 0), message: `Please select a Customer Name`};
    }
  },
  customerReference: {
    validator: (val) => {
      return {isValid: (!IsNullOrUndefined(val) && val.trim() !== ''), message: `Please enter a CRN`};
    }
  }
};

const initialAwning = {
  width: 0,
  outsideArmSpacing: 0,
  numberOfArms: 0,
  bracketTotal: 0,
  insideArmSpacing: 0,
  includePelmet: false,
  middleArmSideDescription: 'Left',
  productArmBracketDeadSpace: 0,
  mountingBracketWidth: 0,
  number: 1,
  productId: null,
  projection: 0,
  driveMechanismId: null,
  id: 1,
  fabricSuppliedBy: 1,
};

class FabricationOrdersEditPage extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      order: null,  
      saving: false,
      awningMessages: new Map(),
      loaded: false,
      organisation: props.user.organisation,
      fabmodSupplierShortName: '',
    };

    this.handleAwningMessagesChanged = this.handleAwningMessagesChanged.bind(this);
    this.handleOnSelectedAwningChange = this.handleOnSelectedAwningChange.bind(this);
    this.saveOrder = this.saveOrder.bind(this);
    this.awningRef = React.createRef();
    this.loadOrder = this.loadOrder.bind(this);
    this.handleOrganisationChange = this.handleOrganisationChange.bind(this);
  }

  componentDidMount() {
    // FABMOD orders always go to Nolans, so the "{group} PO" label and sourcing warnings name
    // Nolans rather than the customer's own group (an Aluxor customer would otherwise see "Aluxor PO").
    apiRequest('/api/fabrications/supplier')
      .then(x => {
        if (x && !x.error && x.data) {
          this.setState({fabmodSupplierShortName: x.data.shortName || ''});
        }
      });

    if(this.props.fabricationOrderId > 0 && this.state.loaded === false) {
      this.loadOrder();
      return;
    }
    
    let {user} = this.props;
    
    let order = newOrder(user.organisation.id);
    order.awnings = [{...initialAwning}];
    
    this.setState({      
      order,
    });
  }
  
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.fabricationOrderId !== this.props.fabricationOrderId || (!this.state.loaded && this.props.fabricationOrderId > 0)) {
      this.loadOrder();
      return;
    }
  }

  handleOnSelectedAwningChange(awning) {
    let {order, organisation} = this.state;
    if(JSON.stringify(order.awnings[0]) !== JSON.stringify(awning))
    {
      // The order already carries its own organisationId (newOrder() for a new order, the API for a
      // loaded one). Only fall back to component state if it is somehow missing — overwriting it
      // unconditionally posted organisationId: undefined whenever the organisation lookup in
      // loadOrder() missed, and the save then failed on the server.
      this.setState({order: {
          ...this.state.order,
          awnings: [{...awning}],
          organisationId: this.state.order.organisationId || organisation.id,
        }
      });
    }
  }

  handleOrganisationChange(value) {
    // SelectControl is simpleValue, so react-select hands back the id as a string.
    let organisationId = parseInt(value, 10);
    let organisation = this.props.organisations.items.filter(x => x.id === organisationId)[0];

    this.setState({
      order: {...this.state.order, organisationId: isNaN(organisationId) ? null : organisationId},
      organisation: organisation ? {...organisation} : this.state.organisation,
    });
  }

  // The group PO stands in for the distributor prefix, so it is only asked for -- and only
  // required -- when the user has no distributor name of their own.
  showGroupPurchaseOrder() {
    return isNullEmptyOrWhitespace(this.props.user.distributorName);
  }

  // Labelled with the group of the customer the order is for, so the label reads the same on
  // the edit page as it does on a sheet someone else prints.
  groupShortName() {
    return this.state.fabmodSupplierShortName;
  }

  // Automation cable, sensors and motors aren't supplied as part of a group/distributor
  // FabMod order -- flag it near Save whenever any of those has been selected.
  needsIndependentSourcing() {
    let awning = this.state.order && this.state.order.awnings && this.state.order.awnings[0];
    if (!awning) {
      return false;
    }
    return !!(awning.automationSensorType || awning.automationCableId || awning.motorId);
  }

  // Calculated, never stored: the server derives the same value from the order creator's
  // distributor name, so re-saving cannot double up the prefix.
  customerReferenceDisplay() {
    let {distributorName} = this.props.user;
    let {customerReference} = this.state.order || {};
    return isNullEmptyOrWhitespace(distributorName)
        ? customerReference
        : `${distributorName}-${customerReference || ''}`;
  }

  validationRules() {
    if (!this.showGroupPurchaseOrder()) {
      return ValidationRules;
    }

    return {
      ...ValidationRules,
      groupPurchaseOrder: {
        validator: (val) => {
          return {isValid: (!IsNullOrUndefined(val) && val.trim() !== ''), message: `Please enter a ${this.groupShortName()} PO`};
        }
      }
    };
  }

  handleAwningMessagesChanged(awningId, messages) {
    let {awningMessages} = this.state;
    awningMessages.set(awningId, messages);
    this.setState({awningMessages: new Map(Array.from(awningMessages))});
  }

  async saveOrder (e){
    let {order} = this.state;
    let messages = {};
    let isValid = true;
    let inValidAwnings = new Set();
    let toPost = {...this.state.order};
    
    let rules = this.validationRules();
    for (let propName in rules) {
      let rule = rules[propName];
      let val = toPost[propName];
      let valResult = rule.validator(val);
      if (!valResult.isValid) {
        messages[propName] = valResult.message;
        isValid = false;
      }
    }

    for(let i = 0; i< order.awnings.length;i++) {
      if (IsNullOrUndefined(order.awnings[i].parentOrderAwningId)) {
        if (this.awningRef.current && !this.awningRef.current.isValid()) {
          isValid = false;
          inValidAwnings.add(order.awnings[i].id);
        } else {
          inValidAwnings.delete(order.awnings[i].id);
        }
      }
    }
    
    if (isValid) {
      this.setState({saving: true});
      
      await apiPost(`/api/fabrications/save`, toPost)
          .then(x => {
            if(x.error){
              this.setState({saving: false});
            } else {
              this.setState({saving: false, order: {...x.data}});
              this.props.history.push(`/fabricationOrders/view/${x.data.id}`);
            }
          })
          .catch(x => {
            console.log(x);
            toastr.error('Error saving fabrication order ' + x);
            this.setState({saving: false, order: toPost});
          });
      
    } else {
      this.setState({validationMessages: messages, inValidAwnings});
    }
  }

  loadOrder() {
    if (this.props.fabricationOrderId > 0 && this.props.organisations.loaded) {
      apiRequest(`/api/fabrications/?id=${this.props.fabricationOrderId}`)
          .then(x => {
            // Spreading a missed lookup gives {}, which leaves organisation.id undefined and takes
            // the order's organisationId with it on the next awning change.
            const organisation = this.props.organisations.items.filter(y => y.id === x.data.organisationId)[0]
                || this.props.user.organisation;

            this.setState({
              order: {...x.data},
              loaded: true,
              organisation: {...organisation},
            });
          });
    }
  }

  render(){

    let {order, saving, validationMessages, loaded} = this.state;
    let {customerReference} = order || {};
    let {user, siteSettings, fabricationOrderId, organisations} = this.props;

    let isValid =  Array.from(this.state.awningMessages.values()).
    filter(x => {
      return some(Object.keys(x.validationMessages), y => x.validationMessages[y] !== '');
    }).length === 0;
    
    return (
      <div className="pi-section">
        
        <h4 style={{marginTop: '10px'}}>Fabrication Order Page</h4>
        
        <div className="pi-row">
          <div className="pi-col-md-9">
            { !IsNullOrUndefined(order) && organisations.loaded &&
                <>
                  <Aux>
                    <SelectControl
                        onChange={this.handleOrganisationChange}
                        labelText="Customer Name"
                        name="organisationId"
                        options={organisations.items}
                        simpleValue={true}
                        value={order.organisationId}
                        valueKey={'id'}
                        labelKey={'description'}
                        placeholder="Select Organisation"
                        validationMessages={validationMessages}
                    />
                    
                    {/*This will get set as customerReference in the order, so that the awning sheets can use it*/}
                    <TextBoxControl
                        onChange={e =>  this.setState({order: {...order, customerReference: e.target.value}})}
                        labelText="CRN"
                        value={customerReference}
                        name="customerReference"
                        validationMessages={validationMessages}
                    />

                    { !this.showGroupPurchaseOrder() &&
                        <TextViewControl labelText={'CRN on sheets'} value={this.customerReferenceDisplay()} /> }

                    { user.hasAccessTag(fabmod_send_po_to_nolans_all) &&
                        <div className="pi-row">
                          <div className="pi-col-sm-12">
                            <label htmlFor="requestedDeliveryDate" style={{minWidth: '150px'}}>Requested Delivery Date&nbsp;</label>
                            <DatePicker
                                onChange={(d) => this.setState({order: {...this.state.order, requestedDeliveryDate: d ? d.format() : null}})}
                                selected={order.requestedDeliveryDate ? moment(order.requestedDeliveryDate) : null}
                                name="requestedDeliveryDate"
                                dateFormat={DATE_SHORT_FORMAT}
                                isClearable={true}
                            />
                          </div>
                        </div> }

                    { this.showGroupPurchaseOrder() &&
                        <TextBoxControl
                            onChange={e =>  this.setState({order: {...order, groupPurchaseOrder: e.target.value}})}
                            labelText={`${this.groupShortName()} PO`}
                            value={order.groupPurchaseOrder || ''}
                            name="groupPurchaseOrder"
                            validationMessages={validationMessages}
                        /> }

                    { ((fabricationOrderId > 0 && loaded) || fabricationOrderId === undefined) && <FabricationAwning
                        ref={this.awningRef}
                        key={`awningview-1`}
                        awning={order.awnings[0]}
                        isVisible={true}
                        onChange={this.handleOnSelectedAwningChange}
                        onMessagesChange={this.handleAwningMessagesChanged}
                        order={order}
                        user={user}
                        date={moment().format(DATE_SHORT_FORMAT)}
                        siteSettings={siteSettings}
                        theme={this.props.theme}
                        organisation={this.state.organisation}
                        fabmodSupplierShortName={this.state.fabmodSupplierShortName}
                    /> }
                    

                    {order.awnings[0].productId > 0 && (
                        <TextBoxControl
                            onChange={e => this.setState({order: {...this.state.order, orderNote: e.target.value}})}
                            labelText="Order Note (optional)"
                            value={order.orderNote}
                            name="orderNote"
                            validationMessages={validationMessages}
                        />
                    )}
                  </Aux>

                  {user.hasAccessTag(fabmod_send_po_to_nolans_all) && this.needsIndependentSourcing() && <div style={{color: '#ae2128', marginBottom: '10px'}}>
                    <i className={'fa fa-exclamation-triangle'}/>&nbsp;Motor, sensors and automation accessories need to be sourced independently of {this.groupShortName()}
                  </div>}

                  <button
                      disabled={saving}
                      onClick={this.saveOrder}
                      className="btn pi-btn-base pi-uppercase pi-weight-700 pi-letter-spacing"
                      style={{marginRight: '10px'}}>
                    <i className="icon-floppy pi-icon-left"></i>&nbsp;Save Fabrication
                  </button>
                  {!isValid && <div style={{color: 'red'}}>Please complete all required fields</div> }
                </>
            }
          </div>
          <div className="pi-col-md-3">
            <div className="pi-box pi-border pi-round pi-border-top">
              <h6 className="pi-weight-600">
                Order Notes
              </h6>

              {(() => {
                let message = Array.from(this.state.awningMessages)[0];
                if (IsNullOrUndefined(message)) return <span><i>No messages</i></span>;

                let a = this.state.order.awnings.filter(y => y.id === message[0])[0];
                if (IsNullOrUndefined(a)) return <span><i>No messages</i></span>;

                let messages = Array.from(message[1].messages);
                let validationMessages = Object.values(message[1].validationMessages).filter(x => x != '');

                return (
                    <div key={a.id}>
                      {messages.length > 0 || validationMessages.length > 0 ?
                          <ul>
                            {messages.map((y, i) => {
                              return (<li key={`message-${a.id}${i}`}>{y}</li>);
                            })}
                            {validationMessages.map((y, i) => {
                              return (<li style={{color:'red'}} key={`vmessage-${a.id}${i}`}>{y}</li>);
                            })}
                          </ul>
                          : <span><i>No messages</i></span>
                      }
                    </div>
                );
              })()}
  
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>      
    );
  }
}

FabricationOrdersEditPage.propTypes = {
  fabricationOrderId: PropTypes.number,
  user: PropTypes.object,
};

function mapStateToProps(state, ownProps) {
  let fabricationOrderId = undefined;
  if (ownProps.match.params && ownProps.match.params.fabricationOrderId) {
    fabricationOrderId = parseInt(ownProps.match.params.fabricationOrderId);
  }

  return {
    fabricationOrderId: fabricationOrderId,
    user: state.user,
    siteSettings: state.lookups.siteSettings,
    theme: state.theme,
    organisations: state.organisations,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FabricationOrdersEditPage));